import React, { useRef } from "react";

import { cloneElement } from 'react';

import {
  DateField,
  List,
  Show,
  ReferenceField,
  SimpleShowLayout,
  TextField,
  ReferenceInput,

  Datagrid,
  SimpleFormIterator,
  ArrayInput,

  TopToolbar,
  useCreate, useNotify, ArrayField,
  useRefresh,
  useRedirect,
  SimpleForm,
  Edit,
  CreateButton,
  SelectInput,
  usePermissions,
  Filter,
  TextInput,
  ImageField,
  FormDataConsumer,

} from "react-admin";
// import { useDownloadExcel } from 'react-export-table-to-excel';
import ReactHTMLTableToExcel from "react-html-table-to-excel";


import { ROLES } from '../../constants';

import CreateView from "../../components/CreateView";
// import ShowView from "../../components/ShowView";



const ReportFilter = (props) => {
  const { permissions } = usePermissions();

  return (
    <Filter {...props}>

      {(permissions?.includes(ROLES.SUPER_ADMIN) || permissions?.includes(ROLES.USERS_ADMIN) || permissions?.includes(ROLES.ANBAAR_ADMIN) || permissions?.includes(ROLES.SALE_ADMIN)) && <ReferenceInput label="واحد مربوطه " source="unitId" reference="unit" >
        <SelectInput optionText="title" />
      </ReferenceInput>}
      {/* <MaterialDateTimeInput
        source="start"
        options={{ format: 'DD/MM/YYYY', label: "از" }}
        alwaysOn
      >salam</MaterialDateTimeInput>
      <MaterialDateTimeInput
        source="end"
        options={{ format: 'DD/MM/YYYY', label: "تا" }}
        alwaysOn
      /> */}


    </Filter>
  )
};


const CreateTemplateButton = ({ record }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [create, { isLoading }] = useCreate(
    'report',
    { isTemplate: true },
    {
      onSuccess: (data) => {
        console.log(data)
        // success side effects go here
        redirect('edit', 'report', data.data.id);

      },
      onError: (error) => {
        // failure side effects go here 
        notify(`خطا در ایجاد گزارش : ${error.message}`, { type: 'warning' });
      },
    }
  );

  return <CreateButton label="ایجاد و ویرایش گزارش " onClick={(e) => { e.preventDefault(); e.stopPropagation(); create() }} disabled={isLoading} />;
};

const ListActions = (props) => {

  return (
    <TopToolbar>
      {/* <CreateButton onClick={(e) => {e.preventDefault();e.stopPropagation();
       handleClick(); 
  }}
    /> */}
      {cloneElement(props.filters, { context: 'button' })}
      <CreateTemplateButton />
    </TopToolbar>
  )
};



export const ReportList = (props) => {

  return (
    <List {...props} actions={<ListActions />}
      filters={<ReportFilter />}
      sort={{ field: 'updatedAt', order: 'DESC' }} >
      <Datagrid rowClick="show" >
        <ReferenceField link={null} label="واحد مربوطه " source="unitId" reference="unit" >
          <TextField source="title" />
        </ReferenceField>

        {/* <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
        <TextField source="title" />
      </ReferenceField> */}
        <TextField source="user.name" label="ساخته شده توسط" />
        {/* <TextField source="objectId"/> */}
        <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="updatedAt" label=" بروزرسانی  " />
        {/* <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="createdAt" label=" تاریخ ایجاد  " /> */}
      </Datagrid>
    </List>
  )
};

export const ReportEdit = (props) => {
  const refresh = useRefresh();

  setTimeout(function () {
    refresh();
  }, 2000);
  return (
    <Edit {...props} actions={null} >
      <SimpleForm variant="outlined" submitOnEnter={false}>
        <ArrayInput source="products" label="">
          <SimpleFormIterator className="grid grid-flow-row-dense mx:grid-cols-1 md:grid-cols-3 grid-rows-3  border-spacing-6 border-cyan-400" disableRemove disableAdd disableReordering>
            <FormDataConsumer >
              {({ formData, ...rest }) => (
                // <div className="grid grid-flow-col items-center border-spacing-6 border border-cyan-400">
                <div>
                  <ImageField {...rest} source="productId.icon" className="align-middle" />
                  <TextField {...rest} source="productId.title" />
                </div>


              )}
            </FormDataConsumer>
            <TextInput variant="outlined" locales={"fa"} label=""
              onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
              source="supply"
            />
            {/* <ReferenceInput label="اقلام" source="productId" reference="product"> */}
            {/* <TextInput source="productId.title" style={{ float: 'right', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80px', top: '20%', width: '30%' }} /> */}
            {/* <SelectField optionText="title" /> */}
            {/* </ReferenceInput> */}
            {/* <SelectField optionText="title" /> */}




          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit >
  )
};

// export const customAction = ({ record, props }) => {
//   console.log("inside action", record)
// }
// const PostShowActions = () => {
//   return <TopToolbar><Button label="ایجاد گزارش" onClick={customAction} /></TopToolbar>
// };

export const ReportShow = (props) => {
  const tableRef = useRef(null);
  //   const { onDownload } = useDownloadExcel({
  //     currentTableRef: tableRef.current,
  //     filename: 'Users table',
  //     sheet: 'Users'
  // })

  return (<Show {...props} actions={null}>
    {/* <Button onClick={onDownload}> Export excel </Button> */}

    <SimpleShowLayout>

      <ReferenceField link={null} label="واحد مربوطه " source="unitId" reference="unit" >
        <TextField source="title" />
      </ReferenceField>

      <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
        <TextField source="title" />
      </ReferenceField>
      <TextField source="user.name" label="ساخته شده توسط" />
      {/* <TextField source="objectId"/> */}
      <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="updatedAt" label=" آخرین بروزرسانی " />
      <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="createdAt" label=" تاریخ ایجاد " />

      <ReactHTMLTableToExcel
        id="table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename="export-report"
        sheet="export"
        buttonText="دریافت فایل خروجی"
      />

      <ArrayField source="products" label=" ">
        {/* <SimpleFormIterator disableRemove disableAdd disableReordering> */}
        <Datagrid id="table-to-xls" ref={tableRef}>


          {/* <ReferenceField link={null} label="اقلام" source="productId" reference="product"> */}
          {/* <SelectField optionText="title" style={{ float: 'right', marginRight: '20px', marginLeft: '10px', width: '30%' }} /> */}
          <TextField source="productId.title" />
          {/* </ReferenceField> */}
          <TextField label="تعداد موجودی" source="supply" style={{ float: 'right', marginRight: '20px', marginLeft: '10px', width: '20%' }} />

          {/* </SimpleFormIterator> */}
        </Datagrid>

      </ArrayField>

    </SimpleShowLayout>
  </Show>
  )
};

export const ReportCreate = (props) => (
  <CreateView {...props}>
  </CreateView>
);
